import { FC, useState } from 'react'
import styles from './CompanyTabs.module.css'
import { CategoryType } from '../../redux/actions/types'

type ProfileCategoriesPropsType = {
  setActiveTab: (tab: number) => void
  activeTab: number
}

const CompanyTabs: FC<ProfileCategoriesPropsType> = ({ setActiveTab, activeTab }) => {
  const onClickHandler = (id: number) => {
    setActiveTab(id)
  }

  return (
    <div className={styles.categoriesBlock}>
      <div className={styles.container}>
        {[
          { title: 'Основная информация', tab: 1 },
          { title: 'Залы компании', tab: 2 },
        ].map((category) => {
          return (
            <div
              onClick={() => onClickHandler(category.tab)}
              key={category.tab}
              className={
                activeTab === category.tab ? `${styles.active} ${styles.category}` : styles.category
              }
            >
              {category.title}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CompanyTabs
